import axios from 'axios';
import reactOnRails from '../utils/reactOnRails';
import MemberCenter from '../pages/MemberCenter';
import '../pages/MemberCenter/services/i18n';

const CsrfToken = document
  .querySelector('meta[name=csrf-token]')
  ?.getAttribute('content');

if (CsrfToken) {
  axios.defaults.headers.common['X-CSRF-Token'] = CsrfToken;
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response.status === 401 &&
      error.response.headers['x-ajax-redirect-url']
    ) {
      window.location.href = error.response.headers['x-ajax-redirect-url'];
    }
    return Promise.reject(error);
  },
);

reactOnRails.register({ MemberCenter });
